import { useGetDriversQuery } from '../services/drivers.service';

type UseDriversProps = {
  companyId?: string;
  search?: string;
  phone?: string;
  page: number;
  pageSize: number;
  skip?: boolean;
};

const useDrivers = ({
  companyId,
  search,
  phone,
  page,
  pageSize,
  skip,
}: UseDriversProps) => {
  const { data, isLoading, error } = useGetDriversQuery(
    {
      companyId,
      search,
      phone,
      paginated: { page, pageSize },
    },
    { skip }
  );

  return {
    isLoading,
    error,
    drivers: data?.items || [],
    totalItems: data?.count || 0,
    totalPages: data?.count ? Math.ceil(data.count / pageSize) : 0,
  };
};

export default useDrivers;
